/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from "@vlinder-web/plugin-agent-service-react";
import {
  HeaderService,
  IHeaderMethods,
  IStaticPageContentMethods,
  StaticPageContentService,
  IGetInviteUserMethods,
  GetInviteUserService,
  SendPurchaseInviteUserService,
  ISendPurchaseInviteMethods,
  MyCommitteInviteStatusService,
  IMyCommitteInviteStatusMethods,
  InviteTableService,
  IInviteTableMethods,
  MasqueraderListsService,
  IMasqueraderListsMethods,
  PresentationListsService,
  IPresentationListsMethods,
  SectionService,
  ISectionMethods,
  IRecallInviteMethods,
  RecallInviteUserService
} from "./components";

export type ManageOpenRegistraionAgent = IHeaderMethods &
  IStaticPageContentMethods &
  IGetInviteUserMethods &
  ISendPurchaseInviteMethods &
  IMyCommitteInviteStatusMethods &
  IRecallInviteMethods &
  IInviteTableMethods &
  IMasqueraderListsMethods &
  IPresentationListsMethods &
  ISectionMethods;

const getPlugins = () => {
  return [
    new StaticPageContentService(),
    new HeaderService(),
    new GetInviteUserService(),
    new RecallInviteUserService(),
    new SendPurchaseInviteUserService(),
    new MyCommitteInviteStatusService(),
    new InviteTableService(),
    new MasqueraderListsService(),
    new PresentationListsService(),
    new SectionService(),
  ];
};

export const getAgent = () => {
  return createAgent<ManageOpenRegistraionAgent>({
    plugins: getPlugins(),
  });
};
